import React, { useContext } from 'react';
import { IUserProfileContext, UserProfileContext } from '../../../../../userProfileState/userProfileContext';
import { UserRoles } from 'types';
import { useTranslation } from 'react-i18next';
import Text from 'components/Text/Text';
import { ItemList } from 'components/ViewPage//ItemList';
import FullInfoField from 'components/FullInfoField/FullInfoField';
import style from './MainInfoTab.module.scss';

export const MainInfoTab: React.FC = () => {
	const { userForUserInfo } = useContext<IUserProfileContext>(UserProfileContext);
	const { t } = useTranslation('form');

	return (
		<div className={style.container}>
			<div className={style.fieldsWrapper}>
				<Text
					translationNameSpace="form"
					translationKey="mainInfoHeading"
					theme="secondary"
					size="l"
					weight="bold"
				/>
				<div className={style.row}>
					<FullInfoField label="emailLabel" value={userForUserInfo?.email || ''} />
					<FullInfoField label="phoneNumberLabel" value={userForUserInfo?.phoneNumber || ''} />
				</div>
				<FullInfoField
					label="roleLabel"
					value={t(userForUserInfo?.roleName || '') as string}
					prefixIcon="asSelect"
					prefixIconName={userForUserInfo?.roleName ? `userRole${userForUserInfo?.roleName}` : undefined}
				/>
			</div>
			{userForUserInfo?.roleName === UserRoles.CLIENT_MANAGER && (
				<div className={style.fieldsWrapper}>
					<Text
						translationNameSpace="form"
						translationKey="customersHeading"
						theme="secondary"
						size="l"
						weight="bold"
					/>
					<FullInfoField label="customerLabel" value={userForUserInfo?.customer?.name} />
				</div>
			)}
			{userForUserInfo?.roleName === UserRoles.GROUP_MANAGER && (
				<div className={style.fieldsWrapper}>
					<div className={style.listWrapper}>
						<Text
							translationNameSpace="form"
							translationKey="customersHeading"
							theme="secondary"
							size="l"
							weight="bold"
						/>
						<ItemList items={userForUserInfo?.customers || []} />
					</div>
				</div>
			)}
			{userForUserInfo?.roleName === UserRoles.RESTAURANT_MANAGER && (
				<div className={style.fieldsWrapper}>
					<Text
						translationNameSpace="form"
						translationKey="customersRestaurantsHeading"
						theme="secondary"
						size="l"
						weight="bold"
					/>
					<FullInfoField label="customerLabel" value={userForUserInfo?.customer?.name} />
					<div className={style.listWrapper}>
						<Text
							translationNameSpace="form"
							translationKey="restaurantsLabel"
							theme="neutralLight"
							size="xs"
						/>
						<ItemList items={userForUserInfo?.restaurants || []} />
					</div>
				</div>
			)}
		</div>
	);
};
